import LanguageDetector from 'i18next-browser-languagedetector'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationFi from './locales/fi/translation.json'
import translationEn from './locales/en/translation.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    resources: {
      fi: {
        translation: translationFi
      },
      en: {
        translation: translationEn
      }
    }
  })

export default i18n
